import {Component, Injector} from '@angular/core';
import {Store, StoreState} from './state/store';
import {Store as StoreModel} from './state/model';
import {EntityListComponent} from '../../components/entity-list/component';
import {FilterService} from './filter.service';
import {StoreQuery} from './state/query';
import {StoreService} from './state/service';

@Component({
  templateUrl: '../../components/entity-list/component.html',
  styleUrls: ['../../components/entity-list/component.scss']
})
export class StoreListComponent extends EntityListComponent<StoreModel, StoreState, Store> {

  translationDomain = 'store';

  constructor(
    public injector: Injector,
    protected service: StoreService,
    query: StoreQuery,
    private StoreFilterService: FilterService) {
    super(injector, service, query, StoreFilterService);
  }
  canEdit(): boolean {
    return this.hasRole('ROLE_ADMIN');
  }
}
